import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { useFetchCatalogItems } from 'entities/CatalogItem/lib/useFetchCatalogItems';
import { useFetchCategories } from 'entities/Category/lib/useFetchCategories';
import { getSelectedCategoryIdToFetch } from 'entities/Category/model/selectors/categorySelectors';
import { getCanAddMarketplaceItemsToOrder } from 'entities/Order/model/selectors/ordersPermissions';
import { ReviewOrderButton, ReviewOrderFooter } from 'features/AddItemsToOrder';
import { addItemsToOrderIsLoading } from 'features/AddItemsToOrder/model/selectors/addItemsToOrderSelectors';
import { getSearchCatalogItemIsActive } from 'features/SearchCatalogItems/model/selectors/searchCatalogItemsSelectors';
import { getRouteOrdersAddItemsCategories } from 'shared/const/router';
import {
    PropertyCatalog,
    PropertyCatalogItemsMoveTo,
} from 'widgets/PropertyCatalog';
import { SearchCatalogItems } from 'widgets/SearchCatalogItems';

export const OrderMarketplacePage = () => {
    const location = useLocation();

    const canAddMarketplaceItems = useSelector(
        getCanAddMarketplaceItemsToOrder,
    );
    const isLoadingUpdateOrder = useSelector(addItemsToOrderIsLoading);
    const isActive = useSelector(getSearchCatalogItemIsActive);
    const selectedCategoryId = useSelector(getSelectedCategoryIdToFetch);

    const orderType = location.state?.orderType;

    const { onFetchGlobalCategories } = useFetchCategories();
    const { onFetchCatalogItems } = useFetchCatalogItems();

    useEffect(() => {
        if (!canAddMarketplaceItems) {
            return;
        }

        onFetchGlobalCategories();
    }, [canAddMarketplaceItems, onFetchGlobalCategories]);

    useEffect(() => {
        if (!canAddMarketplaceItems) {
            return;
        }

        if (selectedCategoryId) {
            onFetchCatalogItems(true);
        }
    }, [canAddMarketplaceItems, selectedCategoryId, onFetchCatalogItems]);

    if (!canAddMarketplaceItems) {
        return (
            <Navigate
                to={getRouteOrdersAddItemsCategories()}
                state={location.state}
                replace
            />
        );
    }

    return (
        <Box display="flex" flexDirection="column">
            <Box sx={{ marginBottom: '16px' }}>
                <SearchCatalogItems
                    mode="global"
                    moveTo={PropertyCatalogItemsMoveTo.ORDER}
                    expandable
                />
            </Box>

            {!isActive && (
                <>
                    <Box
                        display="flex"
                        overflow="hidden"
                        height="calc(100vh - 466px)"
                    >
                        <PropertyCatalog
                            isEditing
                            moveTo={PropertyCatalogItemsMoveTo.ORDER}
                        />
                    </Box>
                    <ReviewOrderFooter>
                        <ReviewOrderButton
                            isLoadingUpdateOrder={isLoadingUpdateOrder}
                            orderType={orderType}
                        />
                    </ReviewOrderFooter>
                </>
            )}
        </Box>
    );
};
